import { getText } from '../internal/TextLabels/text'

class Errors {
  constructor() {
    this.codes = {
      general: {
        code: 0,
        message: getText('errors.general'),
      },
      authFailed: {
        code: 401,
        message: getText('errors.authFailed'),
      },
      notFound: {
        code: 404,
        message: getText('errors.notFound'),
      },
      internalServerError: {
        code: 500,
        message: getText('errors.internalServerError'),
      },
    }
  }
}

export default Errors
